import { LitElement } from 'lit';

/**
 * Class representing a counter for the SkrSplide component.
 * Displays the current slide index and the total number of slides.
 * @extends LitElement
 */
class SkrSplideCounter extends LitElement {
    static get properties() {
        return {
            currentValueEl: { type: HTMLElement },
            totalValueEl: { type: HTMLElement },
            isInitialized: { type: Boolean, attribute: 'is-initialized', reflect: true },
        }
    }

    constructor() {
        super();

        this.isInitialized = false;

        this._update = this._update.bind(this);
    }

    connectedCallback() {
        super.connectedCallback();

        this.currentValueEl = this.querySelector('[data-counter-current-value]') || null;
        this.totalValueEl = this.querySelector('[data-counter-total-value]') || null;
        this.parentContainerSelector = this.getAttribute('parent-container');
        this.parentContainer = this.closest(this.parentContainerSelector);
        
        if (!this.currentValueEl || !this.totalValueEl) {
            console.error('SKR: Could not initialize the skr splide counter');
            return;
        }

        this.parentContainer.addEventListener('skr-slider-moved', this._update);
        this.parentContainer.addEventListener('skr-slider-mounted', this._update);

        this.isInitialized = true;
    }

    disconnectedCallback() {
        super.disconnectedCallback();

        this.parentContainer.removeEventListener('skr-slider-moved', this._update);
        this.parentContainer.removeEventListener('skr-slider-mounted', this._update);
    }

    /**
     * Creates a render root for the LitElement so the element is only a wrapper without rendering any content.
     * @returns {LitElement} The element itself.
     */
    createRenderRoot() {
        return this;
    }

    /**
     * Updates the displayed current and total values when the slider moves or mounts.
     * @param {CustomEvent} event - The event containing the slider details.
     * @private
     */
    _update(event) {
        const current = event.detail.el.index + 1;
        const total = event.detail.el.length;
        this.currentValueEl.textContent = current;
        this.totalValueEl.textContent = total;
    }
}

customElements.define('skr-splide-counter', SkrSplideCounter);
